// extracted by mini-css-extract-plugin
export default {"sum":"total-price_sum_WC48j","bold":"total-price_bold_DtJBD","strike":"total-price_strike_HINHP","discount":"total-price_discount_DwW2x","wrapper":"total-price_wrapper_iccB_"};